<template>

</template>
<script>
import router from '../router'
import navbar from './Navbar'
import { dropdown } from 'vue-strap'

import { EventBus } from '../eventbus.js';


export default {
  name: 'header',
  components: {
    navbar,
    dropdown
  },
  computed: {

    userName: {
      cache: false,
      get: function () {
        console.log("---------userName");
        return localStorage.getItem('local_name')
      }
    }

  },
  mounted () {
    EventBus.$on('userUpdated', u => {
      console.log("new user: " + u);
      this.$forceUpdate();
    });
  },
  methods: {
    click () {
      // do nothing
    },
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
      console.log("------ AppHeader.refresh()");
      this.$forceUpdate();
    },
    sidebarMinimize (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    asideToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    },
    loginSubmit: function (event) {
      localStorage.removeItem('id_token')
      localStorage.clear()
      router.push('/auth/login')
    }
  }
}
</script>



// WEBPACK FOOTER //
// AppHeader.vue?e3d1629e